import { render, staticRenderFns } from "./firm.vue?vue&type=template&id=637ca46a&scoped=true&"
import script from "./firm.vue?vue&type=script&lang=js&"
export * from "./firm.vue?vue&type=script&lang=js&"
import style0 from "./firm.vue?vue&type=style&index=0&id=637ca46a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637ca46a",
  null
  
)

export default component.exports